// LATIR — Programa oficial 2026
// Cada actividad va como una entrada independiente organizada por mes.
// kind: "publica" | "privada" | "pendiente" (define el color/label del tag)

export const PLACEHOLDER = "/brand/placeholder-obra.svg";

export const KIND_LABEL = {
  publica: { es: "Actividad abierta al público", en: "Open activity" },
  privada: { es: "Actividad privada", en: "Private activity" },
  pendiente: { es: "Pendiente de confirmación", en: "To be confirmed" },
};

// Programa oficial 2026. Añadir aquí las actividades cuando estén confirmadas.
// Estructura por entrada:
//   { month: "septiembre"|"octubre", day: 15, time: "18:00 – 20:00",
//     title, titleEn, location, description, descriptionEn, kind }
export const events = [
  {
    month: "septiembre",
    day: 21,
    time: "6:00 p. m.",
    timeEn: "6:00 p.m.",
    title: "Experiencia Gastronómica — El lugar que ocupamos",
    titleEn: "Gastronomic Experience — The place we occupy",
    by: "Chef Raquel Iglesias",
    byEn: "Chef Raquel Iglesias",
    location: "Palacio Nacional",
    locationEn: "Palacio Nacional",
    description:
      "Una experiencia especial que reúne arte, gastronomía y propósito social en el marco de LATIR.",
    descriptionEn:
      "A special experience that brings together art, gastronomy and social purpose within LATIR.",
    kind: "privada",
  },
  {
    month: "septiembre",
    day: 21,
    time: "9:00 p. m.",
    timeEn: "9:00 p.m.",
    title: "Danza — Inquilinos permanentes",
    titleEn: "Dance — Permanent Tenants",
    by: "por Casa Carmen",
    byEn: "by Casa Carmen",
    location: "Casa Carmen",
    locationEn: "Casa Carmen",
    description: "",
    descriptionEn: "",
    kind: "privada",
  },
  {
    month: "septiembre",
    day: 24,
    time: "6:00 p. m.",
    timeEn: "6:00 p.m.",
    title: "Conversatorio — Cóctel de inauguración",
    titleEn: "Conversation — Opening Cocktail",
    location: "Palacio Nacional",
    locationEn: "Palacio Nacional",
    description: "",
    descriptionEn: "",
    kind: "publica",
  },
  {
    month: "septiembre",
    day: 24,
    time: "9:00 p. m.",
    timeEn: "9:00 p.m.",
    title: "Danza — Inquilinos permanentes",
    titleEn: "Dance — Permanent Tenants",
    by: "por Casa Carmen",
    byEn: "by Casa Carmen",
    location: "Palacio Nacional",
    locationEn: "Palacio Nacional",
    description: "",
    descriptionEn: "",
    kind: "publica",
  },
  {
    month: "septiembre",
    day: 26,
    time: "10:30 a. m. – 11:30 a. m.",
    timeEn: "10:30 a.m. – 11:30 a.m.",
    title: "Charla de Concientización #1",
    titleEn: "Awareness Talk #1",
    location: "Palacio Nacional",
    locationEn: "Palacio Nacional",
    description:
      "Dra. Caceros, radióloga. Conversación sobre prevención, estudios de imagen y la importancia de la detección temprana del cáncer de mama.",
    descriptionEn:
      "Dr. Caceros, radiologist. A conversation on prevention, imaging studies and the importance of early detection of breast cancer.",
    kind: "publica",
  },
  {
    month: "octubre",
    day: 1,
    time: "9:00 a. m. – 12:00 p. m.",
    timeEn: "9:00 a.m. – 12:00 p.m.",
    title: "Taller de Kintsugi para sobrevivientes",
    titleEn: "Kintsugi Workshop for Survivors",
    location: "Casa Barro",
    locationEn: "Casa Barro",
    description: "",
    descriptionEn: "",
    kind: "privada",
  },
  {
    month: "octubre",
    day: 3,
    time: "9:00 a. m. – 12:00 p. m.",
    timeEn: "9:00 a.m. – 12:00 p.m.",
    title: "Taller de Kintsugi No. 2",
    titleEn: "Kintsugi Workshop No. 2",
    location: "Casa Barro",
    locationEn: "Casa Barro",
    description: "",
    descriptionEn: "",
    cost: "USD $100",
    kind: "publica",
  },
  {
    month: "octubre",
    day: 8,
    time: "9:00 a. m. – 12:00 p. m.",
    timeEn: "9:00 a.m. – 12:00 p.m.",
    title: "Taller de Kintsugi — Banco Cuscatlán",
    titleEn: "Kintsugi Workshop — Banco Cuscatlán",
    location: "Casa Barro",
    locationEn: "Casa Barro",
    description: "",
    descriptionEn: "",
    kind: "privada",
  },
  {
    month: "octubre",
    day: 10,
    time: "10:30 a. m. – 12:00 p. m.",
    timeEn: "10:30 a.m. – 12:00 p.m.",
    title: "Charla de Concientización #2",
    titleEn: "Awareness Talk #2",
    location: "Palacio Nacional",
    locationEn: "Palacio Nacional",
    description:
      "Normy Morales + Banco Cuscatlán. Un espacio dedicado a testimonios, concientización y herramientas para acompañar el impacto emocional y financiero de un diagnóstico.",
    descriptionEn:
      "Normy Morales + Banco Cuscatlán. A space dedicated to testimonies, awareness and tools to accompany the emotional and financial impact of a diagnosis.",
    kind: "publica",
  },
  {
    month: "octubre",
    day: 10,
    time: "6:30 p. m. – 7:30 p. m.",
    timeEn: "6:30 p.m. – 7:30 p.m.",
    title: "Danza — Inquilinos permanentes",
    titleEn: "Dance — Permanent Tenants",
    by: "por Casa Carmen",
    byEn: "by Casa Carmen",
    location: "Palacio Nacional",
    locationEn: "Palacio Nacional",
    description: "",
    descriptionEn: "",
    kind: "publica",
  },
  {
    month: "octubre",
    day: 15,
    time: "Todo el día",
    timeEn: "All day",
    title: "Último día de la exposición",
    titleEn: "Last day of the exhibition",
    location: "Palacio Nacional",
    locationEn: "Palacio Nacional",
    description: "Cierre de LATIR 2026 en el Palacio Nacional.",
    descriptionEn: "Closing of LATIR 2026 at the Palacio Nacional.",
    kind: "",
  },
];

// Performances confirmados durante la exposición (Casa Carmen).
// Se mantiene aparte para conservar la ficha con imagen, ig, práctica e inspiración.
export const performances = [
  {
    slug: "casa-carmen",
    name: "Casa Carmen",
    title: "Inquilinos Permanentes",
    titleEn: "Permanent Tenants",
    format: "Danza · Performance",
    formatEn: "Dance · Performance",
    instagram: "conlapinto",
    practica:
      "Casa Carmen es un laboratorio artístico donde la danza, el teatro y la música dialogan para habitar lo cotidiano y trascender los límites tradicionales de la escena.",
    practicaEn:
      "Casa Carmen is an artistic laboratory where dance, theater and music dialogue to inhabit the everyday and transcend the traditional limits of the stage.",
    inspiracion:
      "Inquilinos Permanentes es una obra de danza-performance que nace para retratar los espacios que sostienen procesos íntimos: pruebas, duelos y sostenes cotidianos.",
    inspiracionEn:
      "Permanent Tenants is a dance-performance work born to portray the spaces that sustain intimate processes: trials, mournings and everyday supports.",
    bio: "Ale Pinto es una directora y artista salvadoreña cuya obra explora la relación entre el cine, la fotografía y las artes escénicas. Su trabajo se caracteriza por construir narrativas visuales que ponen en el centro la experiencia humana, combinando sensibilidad artística con una mirada contemporánea. Es fundadora de Casa Carmen, un laboratorio creativo dedicado al desarrollo de proyectos escénicos y audiovisuales. Ha sido reconocida con el Premio Ovación 2025 como co-receptora y con los premios a Mejor Dirección y Mejor Dirección de Fotografía en ESCINE 2024. Sus proyectos han sido presentados en espacios culturales y festivales nacionales e internacionales.",
    bioEn:
      "Ale Pinto is a Salvadoran director and artist whose work explores the relationship between cinema, photography and the performing arts. Her work is characterized by building visual narratives that place the human experience at the center, combining artistic sensitivity with a contemporary perspective. She is the founder of Casa Carmen, a creative laboratory dedicated to the development of stage and audiovisual projects. She has been recognized with the 2025 Ovación Award as co-recipient and with the awards for Best Direction and Best Cinematography at ESCINE 2024. Her projects have been presented in cultural spaces and festivals at national and international levels.",
    schedule: [],
    image: "/brand/casa-carmen.webp",
  },
];

// Meses que aparecen en la vista, en orden cronológico.
export const MONTHS = [
  { key: "septiembre", label: { es: "Septiembre", en: "September" } },
  { key: "octubre", label: { es: "Octubre", en: "October" } },
];
